import React from 'react'

import IncidentDate from '../../incidents/components/IncidentDate'
import IncidentDetailsSection from '../../incidents/components/IncidentDetailsSection'
import DetailsSegmentList from './DetailsSegmentList'
import SectionHeader from '../../common/components/SectionHeader'

import { useSelectedClosure } from '../hooks'

import styles from './ClosureDetails.module.css'

const detailFormat = (detail) =>
  (detail && detail.trim ? detail.trim() : detail) || '-'
const detailGroupFormat = (group) => {
  Object.keys(group).forEach((key) => (group[key] = detailFormat(group[key])))
  return group
}

const ClosureDetails = () => {
  const closure = useSelectedClosure()

  if (!closure) return null

  const { closedDate, closedBy, agency, reason, notes } = closure

  /* eslint-disable */
  const editors = detailGroupFormat({
    ['Closed']: <IncidentDate date={closedDate} />,
    ['By']: `${closedBy} (${agency})`,
    ['Reason']: reason,
  })
  /* eslint-enable */

  return (
    <div className={styles.details}>
      <IncidentDetailsSection title="Editors" details={editors} />
      <SectionHeader title="Notes" />
      <span className={styles.comments}>{notes}</span>
      <SectionHeader title="Road Segments" />
      <DetailsSegmentList />
    </div>
  )
}

export default ClosureDetails
